// Stabile, sprachunabhängige Schlüssel; die Beschriftungen kommen aus PHP
// (weissenstadt_favorite_category_labels()). Reihenfolge = Filterreihenfolge.
export const FAVORITE_CATEGORIES = ["stay", "food", "event", "place", "other"];

/** Unknown entries stay under All until public metadata classifies them. */
export function favoriteView(items, requested = "all") {
  const counts = new Map(FAVORITE_CATEGORIES.map((category) => [category, 0]));
  for (const item of items) {
    if (counts.has(item.category))
      counts.set(item.category, counts.get(item.category) + 1);
  }
  const categories = FAVORITE_CATEGORIES.filter((category) =>
    counts.get(category),
  );
  const category =
    categories.length > 1 && counts.get(requested) ? requested : "all";
  return {
    category,
    categories,
    counts,
    items:
      category === "all"
        ? items
        : items.filter((item) => item.category === category),
  };
}
